import { useEffect, useState } from 'react';

import getGames from '../../../components/SearchSelect/facades/getGames.facade';

const useGamesData = ({ selected = [], onGameSelect }) => {
    const [query, setQuery] = useState('');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const combinedData = [
        ...(selected.map(({ id, name }) => ({ value: id, label: name }))),
        ...data,
    ];

    const fetchGames = async (queryParameter = '') => {
        try {
            setLoading(true);
            const response = await getGames(queryParameter);

            setData(response);
        } catch (error) {
            // ignore
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGames(query);
    }, [query]);

    const handleChangeQuery = (value) => {
        setQuery(value);
    };

    const handleGamesSelect = (values) => {
        const valuesWithData = values.reduce((accumulator, id) => {
            const foundGame = combinedData.find((game) => game.value === id);

            if (foundGame) {
                accumulator.push({
                    id: foundGame.value,
                    name: foundGame.label,
                });
            }

            return accumulator;
        }, []);

        onGameSelect(valuesWithData);
    };

    return {
        query,
        loading,
        handleChangeQuery,
        handleGamesSelect,
        data: combinedData,
        selected: selected.map(({ id: gameId }) => gameId) || [],
    };
};

export default useGamesData;
